import React from "react";
import TrackVisibility from "react-on-screen";
import Skill from "../Items/Skill";

const skillData = {
  skillContent:
    "Full-stack developer with a solid understanding of IT infrastructure and network management, capable of handling projects from concept to deployment.",
  progressData: [
    {
      id: 1,
      name: "ReactJS",
      percentage: 90,
    },
    {
      id: 2,
      name: "VueJS",
      percentage: 80,
    },
    {
      id: 3,
      name: "NuxtJS",
      percentage: 75,
    },
    {
      id: 4,
      name: "Wordpress Development",
      percentage: 85,
    },
    {
      id: 5,
      name: "HTML/CSS",
      percentage: 95,
    },
    {
      id: 6,
      name: "IT & Network Management",
      percentage: 60,
    },
    {
      id: 7,
      name: "SCSS",
      percentage: 90,
    },
    {
      id: 8,
      name: "Figma",
      percentage: 80,
    },
    {
      id: 9,
      name: "Adobe XD",
      percentage: 75,
    },
    {
      id: 10,
      name: "Photoshop",
      percentage: 80,
    },
    {
      id: 11,
      name: "Illustrator",
      percentage: 75,
    },
    {
      id: 12,
      name: "Office Package",
      percentage: 80,
    },
  ]
};

function Skills() {
  return (
    <>
      <p className="mb-0">{skillData.skillContent}</p>
      <div className="mt-5">
        <div className="row -mt-50">
          {skillData.progressData.map((progress) => (
            <div className="col-md-6 mt-50" key={progress.id}>
              <TrackVisibility once>
                <Skill progress={progress} />
              </TrackVisibility>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Skills;
